import { render, staticRenderFns } from "./SystemComponentsHierarchyTable.vue?vue&type=template&id=6f8efda8&"
import script from "./SystemComponentsHierarchyTable.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports